__webpack_require__.p = "/resu-folio/";